import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useSubscription } from "@/contexts/subscription-context";
import { Clock, AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";

export function TrialStatusMessage() {
  const navigate = useNavigate();
  const { subscription, isLoading: isSubscriptionLoading } = useSubscription();

  const handleClick = () => {
    // Navigate to settings page with billing tab selected
    navigate("/settings?tab=billing");
  };

  if (isSubscriptionLoading) {
    return null;
  }

  if (!subscription || subscription?.status !== "trialing") {
    return null;
  }

  const { daysRemaining = 0, isExpired } = subscription?.trial || {};

  const getStatusColor = () => {
    if (isExpired) return "text-red-600 bg-red-50 border-red-200";
    if (daysRemaining <= 1)
      return "text-orange-600 bg-orange-50 border-orange-200";
    if (daysRemaining <= 3)
      return "text-yellow-600 bg-yellow-50 border-yellow-200";
    return "text-green-600 bg-green-50 border-green-200";
  };

  const getStatusIcon = () => {
    if (isExpired) return AlertTriangle;
    return Clock;
  };

  const getStatusText = () => {
    if (isExpired) return "Trial expired";
    if (daysRemaining === 1) return "1 day left in trial";
    return `${daysRemaining} days left in trial`;
  };

  const StatusIcon = getStatusIcon();

  return (
    <Button
      variant="outline"
      onClick={handleClick}
      className={cn(
        "w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-all",
        " hover:opacity-90 cursor-pointer",
      )}
    >
      <StatusIcon className={cn("w-3.5 h-3.5", getStatusColor())} />
      <span>{getStatusText()}</span>
    </Button>
  );
}
